export default __webpack_public_path__ + "static/media/js30.15409969.PNG";